(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  const kreenutsFooterTeaser = {
    footer: null,
    footerObserver: null,
    mutationObserver: null,
    footerVisible: false,
    mobileQuery: window.matchMedia('(max-width: 749px)'),

    teasers() {
      const results = [];

      document.querySelectorAll('shopify-forms-embed').forEach((embed) => {
        const root = embed.shadowRoot;
        if (!root) return;

        const teaser =
          root.querySelector('button[class*="_teaser"]') ||
          root.querySelector('button[class*="teaser"]');

        if (teaser) results.push(teaser);
      });

      return results;
    },

    sync() {
      const shouldHide = this.mobileQuery.matches && this.footerVisible;

      this.teasers().forEach((teaser) => {
        if (shouldHide) {
          teaser.dataset.kreenutsFooterHidden = 'true';
          teaser.style.setProperty('opacity', '0', 'important');
          teaser.style.setProperty('visibility', 'hidden', 'important');
          teaser.style.setProperty('pointer-events', 'none', 'important');
        } else if (teaser.dataset.kreenutsFooterHidden === 'true') {
          teaser.style.removeProperty('opacity');
          teaser.style.removeProperty('visibility');
          teaser.style.removeProperty('pointer-events');
          delete teaser.dataset.kreenutsFooterHidden;
        }
      });
    },

    init() {
      const footer = document.querySelector('.footer-content');
      if (!footer || this.footer === footer) {
        this.sync();
        return;
      }

      this.footer = footer;
      this.footerObserver?.disconnect();
      this.mutationObserver?.disconnect();

      this.footerObserver = new IntersectionObserver((entries) => {
        this.footerVisible = entries.some((entry) => entry.isIntersecting);
        this.sync();
      }, { threshold: 0.01 });

      this.footerObserver.observe(footer);

      this.mutationObserver = new MutationObserver(() => this.sync());
      this.mutationObserver.observe(document.body, { childList: true, subtree: true });

      this.mobileQuery.addEventListener?.('change', () => this.sync());
      window.setTimeout(() => this.sync(), 500);
    }
  };

  const initKreenutsFooterTeaser = () => kreenutsFooterTeaser.init();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKreenutsFooterTeaser, { once: true });
  } else {
    initKreenutsFooterTeaser();
  }

  document.addEventListener('shopify:section:load', initKreenutsFooterTeaser);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kreenuts-age-verifier"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kreenuts-age-verifier')) {
    customElements.define('kreenuts-age-verifier', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const dialog = this.querySelector('dialog');
        const key = 'kreenuts-age-' + this.dataset.key;
        const preview = Boolean(window.Shopify?.designMode);
        this.querySelector('[data-preview]')?.addEventListener('click', () => dialog.showModal(), options);
        dialog.addEventListener('cancel', event => { if (!preview) event.preventDefault(); }, options);
        this.querySelector('[data-accept]').addEventListener('click', () => {
          if (!preview) {
            try { localStorage.setItem(key, String(Date.now())); } catch {}
          }
          dialog.close();
        }, options);
        this.querySelector('[data-reject]').addEventListener('click', () => {
          this.querySelector('[data-rejected]').hidden = false;
        }, options);
        if (preview || this.dataset.enabled !== 'true') return;
        let accepted = false;
        try {
          const saved = Number(localStorage.getItem(key) || 0);
          accepted = saved > 0 && Date.now() - saved < Number(this.dataset.days) * 86400000;
        } catch {}
        if (!accepted) dialog.showModal();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.querySelector('dialog')?.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kreenuts-app-stage"] && !Shopify.designMode) return;
  try {
    
  const removeEmptyJudgeMeHeadings = (root) => {
    root.querySelectorAll('.jdgm-cards-carousel h1, .jdgm-cards-carousel h2, .jdgm-cards-carousel h3, .jdgm-cards-carousel h4, .jdgm-cards-carousel h5, .jdgm-cards-carousel h6').forEach((heading) => {
      const text = (heading.textContent || '').replace(/\s+/g, ' ').trim();
      const ariaLabel = (heading.getAttribute('aria-label') || '').trim();
      if (!text && !ariaLabel) heading.remove();
    });
  };

  const placeJudgeMeVerified = (root) => {
    const carousel = root.querySelector('.jdgm-cards-carousel');
    if (!carousel) return false;

    removeEmptyJudgeMeHeadings(root);

    const outsideReviewCard = (element) => !element.closest('.jm-review-item');

    const verified = [...carousel.querySelectorAll('*')]
      .filter((element) => {
        if (!outsideReviewCard(element)) return false;
        const text = (element.textContent || '').replace(/\s+/g, ' ').trim();
        return /^verified$/i.test(text) && element.querySelectorAll('*').length <= 3;
      })
      .sort((a, b) => a.querySelectorAll('*').length - b.querySelectorAll('*').length)[0];

    if (!verified) return false;

    const rating = [...carousel.querySelectorAll('*')]
      .filter((element) => {
        if (!outsideReviewCard(element) || element.contains(verified)) return false;
        const text = (element.textContent || '').replace(/\s+/g, ' ').trim();
        return /^\d(?:\.\d+)?\s*★\s*\(\d+\)$/.test(text);
      })
      .sort((a, b) => (a.textContent || '').length - (b.textContent || '').length)[0];

    if (!rating) return false;

    rating.classList.add('k-jdgm-rating-line');
    verified.classList.add('k-jdgm-verified-inline');

    if (!rating.contains(verified)) {
      rating.appendChild(verified);
    }

    return true;
  };

  const initJudgeMeVerified = () => {
    document.querySelectorAll('.k-app-stage--reviews').forEach((root) => {
      if (placeJudgeMeVerified(root)) return;

      const observer = new MutationObserver(() => {
        if (placeJudgeMeVerified(root)) observer.disconnect();
      });

      observer.observe(root, { childList: true, subtree: true });
      window.setTimeout(() => observer.disconnect(), 10000);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJudgeMeVerified, { once: true });
  } else {
    initJudgeMeVerified();
  }

  document.addEventListener('shopify:section:load', initJudgeMeVerified);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kreenuts-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kreenuts-collection-tabs')) {
    customElements.define('kreenuts-collection-tabs', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', this.handleClick, options);
        this.addEventListener('keydown', this.handleKeydown, options);
        this.addEventListener('shopify:block:select', this.handleBlockSelect, options);
      }

      get tabs() { return [...this.querySelectorAll('[data-k-tab]')]; }
      get panels() { return [...this.querySelectorAll('[data-k-panel]')]; }

      handleClick = (event) => {
        if (!(event.target instanceof Element)) return;
        const tab = event.target.closest('[data-k-tab]');
        if (!tab || !this.contains(tab)) return;
        this.select(tab);
      };

      handleKeydown = (event) => {
        if (!(event.target instanceof Element)) return;
        const tab = event.target.closest('[data-k-tab]');
        if (!tab || !this.contains(tab)) return;
        const tabs = this.tabs;
        const index = tabs.indexOf(tab);
        const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + direction + tabs.length) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - direction + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === index) return;
        event.preventDefault();
        this.select(tabs[nextIndex], true);
      };

      handleBlockSelect = (event) => {
        if (!(event.target instanceof Element)) return;
        const tab = event.target.closest('[data-k-tab]');
        if (tab && this.contains(tab)) this.select(tab);
      };

      select(selectedTab, focus = false) {
        const tabs = this.tabs;
        const panels = this.panels;
        tabs.forEach((tab, itemIndex) => {
          const selected = tab === selectedTab;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          if (panels[itemIndex]) panels[itemIndex].hidden = !selected;
        });
        if (focus) selectedTab.focus();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kreenuts-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kreenuts-countdown')) {
    customElements.define('kreenuts-countdown', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.timer);
        const value = this.dataset.kCountdown || '';
        const end = /T.*(?:Z|[+-]\d{2}:\d{2})$/.test(value) ? Date.parse(value) : NaN;
        const clock = this.querySelector('.k-countdown__clock');
        const expired = this.querySelector('[data-expired]');
        const invalid = this.querySelector('[data-invalid]');
        const link = this.querySelector('.k-countdown__inner > a');
        clock.hidden = false;
        expired.hidden = true;
        if (invalid) invalid.hidden = true;
        if (link) link.hidden = false;
        if (!Number.isFinite(end)) {
          this.hidden = !window.Shopify?.designMode;
          clock.hidden = true;
          if (invalid) invalid.hidden = false;
          return;
        }
        this.hidden = false;
        const update = () => {
          const remaining = Math.max(0, end - Date.now());
          if (!remaining) {
            clearInterval(this.timer);
            clock.hidden = true;
            expired.hidden = false;
            if (link) link.hidden = true;
            this.hidden = this.dataset.expiry === 'hide' && !window.Shopify?.designMode;
            return;
          }
          const values = [Math.floor(remaining / 86400000), Math.floor(remaining / 3600000) % 24, Math.floor(remaining / 60000) % 60, Math.floor(remaining / 1000) % 60];
          ['days', 'hours', 'minutes', 'seconds'].forEach((field, index) => {
            this.querySelector('[data-' + field + ']').textContent = String(values[index]).padStart(2, '0');
          });
        };
        update();
        if (end > Date.now()) this.timer = setInterval(update, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kreenuts-featured-crunch"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kreenuts-featured-crunch')) {
    customElements.define('kreenuts-featured-crunch', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.k-featured-crunch__track');
        this.slides = [...this.querySelectorAll('[data-featured-slide]')];
        this.prev = this.querySelector('[data-featured-prev]');
        this.next = this.querySelector('[data-featured-next]');
        if (!this.track || !this.slides.length) return;

        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.prev?.addEventListener('click', () => this.go(-1), options);
        this.next?.addEventListener('click', () => this.go(1), options);

        this.observer?.disconnect();
        this.observer = new IntersectionObserver(this.onIntersect, { root: this.track, threshold: [0.45, 0.65, 0.85] });
        this.slides.forEach((slide) => this.observer.observe(slide));

        const initial = Math.min(this.slides.length - 1, Math.max(0, Number.parseInt(this.dataset.initialIndex || '0', 10)));
        requestAnimationFrame(() => this.centerSlide(initial, false));
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }

      onIntersect = (entries) => {
        let best = null;
        entries.forEach((entry) => {
          if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
        });
        if (!best || best.intersectionRatio < .45) return;
        this.slides.forEach((slide) => slide.classList.toggle('is-active', slide === best.target));
      };

      currentIndex = () => {
        const trackRect = this.track.getBoundingClientRect();
        const trackCenter = trackRect.left + trackRect.width / 2;
        let index = 0;
        let distance = Infinity;
        this.slides.forEach((slide, i) => {
          const rect = slide.getBoundingClientRect();
          const delta = Math.abs((rect.left + rect.width / 2) - trackCenter);
          if (delta < distance) { distance = delta; index = i; }
        });
        return index;
      };

      centerSlide(index, smooth = true) {
        const slide = this.slides[index];
        if (!slide) return;
        const left = slide.offsetLeft - (this.track.clientWidth - slide.offsetWidth) / 2;
        this.track.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
        this.slides.forEach((item, i) => item.classList.toggle('is-active', i === index));
      }

      go(direction) {
        const nextIndex = (this.currentIndex() + direction + this.slides.length) % this.slides.length;
        this.centerSlide(nextIndex);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kreenuts-flavour-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kreenuts-range-carousel')) {
    customElements.define('kreenuts-range-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.kreenuts-range-showcase__track');
        this.prev = this.querySelector('[data-range-prev]');
        this.next = this.querySelector('[data-range-next]');
        this.refreshSlides();
        if (!this.track || !this.slides.length) return;

        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.prev?.addEventListener('click', () => this.go(-1), options);
        this.next?.addEventListener('click', () => this.go(1), options);
        this.track.addEventListener('scroll', this.onScroll, { signal: this.controller.signal, passive: true });

        const initialSlide = this.slides.find((slide) => slide.hasAttribute('data-start-featured')) || this.slides[0];
        requestAnimationFrame(() => {
          this.centerElement(initialSlide, false);
          this.updateActive();
          this.rebalance();
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        if (this.raf) cancelAnimationFrame(this.raf);
        if (this.restoreRaf) cancelAnimationFrame(this.restoreRaf);
      }

      refreshSlides = () => {
        this.slides = this.track ? [...this.track.querySelectorAll('[data-range-slide]')] : [];
      };

      onScroll = () => {
        if (this.rebalancing || this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          this.updateActive();
          this.rebalance();
        });
      };

      updateActive = () => {
        this.refreshSlides();
        const index = this.currentIndex();
        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      };

      currentIndex = () => {
        if (!this.track || !this.slides.length) return 0;
        const trackRect = this.track.getBoundingClientRect();
        const center = trackRect.left + trackRect.width / 2;
        let index = 0;
        let distance = Infinity;
        this.slides.forEach((slide, i) => {
          const rect = slide.getBoundingClientRect();
          const delta = Math.abs((rect.left + rect.width / 2) - center);
          if (delta < distance) { distance = delta; index = i; }
        });
        return index;
      };

      slideStep = () => {
        this.refreshSlides();
        if (this.slides.length > 1) {
          const step = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
          if (step > 0) return step;
        }
        const styles = getComputedStyle(this.track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        return (this.slides[0]?.offsetWidth || 0) + gap;
      };

      rebalance = () => {
        this.refreshSlides();
        if (this.slides.length < 4 || this.rebalancing) return;

        let index = this.currentIndex();
        const buffer = Math.min(2, Math.floor((this.slides.length - 1) / 2));
        const step = this.slideStep();
        let delta = 0;

        if (!step || (index >= buffer && index <= this.slides.length - 1 - buffer)) return;

        this.rebalancing = true;
        const snap = this.track.style.scrollSnapType;
        const behavior = this.track.style.scrollBehavior;
        this.track.style.scrollSnapType = 'none';
        this.track.style.scrollBehavior = 'auto';

        while (index < buffer) {
          const last = this.slides[this.slides.length - 1];
          this.track.prepend(last);
          delta += step;
          this.refreshSlides();
          index += 1;
        }

        while (index > this.slides.length - 1 - buffer) {
          const first = this.slides[0];
          this.track.append(first);
          delta -= step;
          this.refreshSlides();
          index -= 1;
        }

        if (delta) this.track.scrollLeft += delta;

        this.restoreRaf = requestAnimationFrame(() => {
          this.track.style.scrollSnapType = snap;
          this.track.style.scrollBehavior = behavior;
          this.rebalancing = false;
          this.updateActive();
        });
      };

      centerElement(slide, smooth = true) {
        if (!slide) return;
        const left = slide.offsetLeft - (this.track.clientWidth - slide.offsetWidth) / 2;
        this.track.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
        this.refreshSlides();
        this.slides.forEach((item) => item.classList.toggle('is-active', item === slide));
      }

      centerSlide(index, smooth = true) {
        this.refreshSlides();
        this.centerElement(this.slides[index], smooth);
      }

      go(direction) {
        this.refreshSlides();
        if (this.slides.length < 2) return;

        this.rebalance();
        requestAnimationFrame(() => {
          this.refreshSlides();
          const index = this.currentIndex();
          const nextIndex = index + direction;
          if (this.slides[nextIndex]) this.centerSlide(nextIndex);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kreenuts-home-street-reel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const media = event.target.closest('.k-home-street__media');
    if (!media) return;

    const video = media.querySelector('video');
    if (!video) return;

    if (video.paused) {
      video.play().then(() => {
        media.classList.add('is-playing');
      }).catch(() => {});
    } else {
      video.pause();
      media.classList.remove('is-playing');
    }
  });

  document.addEventListener('pause', (event) => {
    if (!(event.target instanceof HTMLVideoElement)) return;
    event.target.closest('.k-home-street__media')?.classList.remove('is-playing');
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kreenuts-horizontal-banners"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kreenuts-horizontal-banners')) {
    customElements.define('kreenuts-horizontal-banners', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = new AbortController();
        this.scene = this.querySelector('.k-horizontal__scene');
        this.track = this.querySelector('.k-horizontal__track');
        this.scrollTarget = this.closest('.page-wrapper') || window;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = matchMedia('(min-width: 990px)');
        const options = { signal: this.controller.signal };
        this.scrollTarget.addEventListener('scroll', this.update, { ...options, passive: true });
        this.reducedMotion.addEventListener('change', this.measure, options);
        this.desktop.addEventListener('change', this.measure, options);
        this.resizeObserver = new ResizeObserver(this.measure);
        this.resizeObserver.observe(this);
        if (this.track) this.resizeObserver.observe(this.track);
        requestAnimationFrame(this.measure);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }

      measure = () => {
        if (!this.scene || !this.track) return;
        if (!this.desktop.matches || this.reducedMotion.matches) {
          this.style.removeProperty('--horizontal-scroll-height');
          this.style.removeProperty('--horizontal-shift');
          return;
        }
        const travel = Math.max(0, this.track.scrollWidth - this.clientWidth);
        this.travel = travel;
        this.style.setProperty('--horizontal-scroll-height', `${this.scene.offsetHeight + travel}px`);
        this.update();
      };

      update = () => {
        if (!this.desktop?.matches || this.reducedMotion?.matches || !this.scene || !this.track) return;
        const distance = Math.max(1, this.offsetHeight - this.scene.offsetHeight);
        const progress = Math.min(1, Math.max(0, -this.getBoundingClientRect().top / distance));
        const direction = getComputedStyle(this).direction === 'rtl' ? 1 : -1;
        this.style.setProperty('--horizontal-shift', `${progress * (this.travel || 0) * direction}px`);
      };
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kreenuts-launch-waitlist"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kreenuts-launch-waitlist')) {
    customElements.define('kreenuts-launch-waitlist', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-launch-dialog]');
        this.closeButton = this.querySelector('[data-launch-close]');
        this.serverWaitlisted = this.dataset.serverWaitlisted === 'true';
        this.closeButton?.addEventListener('click', () => this.dialog?.close());

        this.dialog?.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          const outside =
            event.clientX < rect.left ||
            event.clientX > rect.right ||
            event.clientY < rect.top ||
            event.clientY > rect.bottom;
          if (outside) this.dialog.close();
        });

        if (this.querySelector('[data-launch-success]')) {
          try { localStorage.setItem('kreenuts-launch-waitlist-joined', '1'); } catch {}
          this.open(true);
        }
      }

      hasJoined() {
        if (this.serverWaitlisted) return true;
        try { return localStorage.getItem('kreenuts-launch-waitlist-joined') === '1'; }
        catch { return false; }
      }

      open(force = false) {
        if (!this.dialog || this.dialog.open) return;
        this.dialog.showModal();
        requestAnimationFrame(() => {
          const email = this.dialog.querySelector('input[type="email"]');
          if (email instanceof HTMLElement) email.focus();
          else this.closeButton?.focus();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kreenuts-layer-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kreenuts-story-media')) {
    customElements.define('kreenuts-story-media', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.preference = matchMedia('(prefers-reduced-motion: reduce)');
        this.updateMotion();
        this.preference.addEventListener('change', () => this.updateMotion(), { signal: this.controller.signal });
      }
      updateMotion() {
        const video = this.querySelector('video');
        if (!video) return;
        if (this.preference.matches) video.pause();
        else if (video.autoplay) video.play().catch(() => {});
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kreenuts-media-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kreenuts-media-grid')) {
    customElements.define('kreenuts-media-grid', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
        this.videos = [...this.querySelectorAll('video[autoplay]')];
        this.updateMotion();
        this.motionPreference.addEventListener('change', () => this.updateMotion(), { signal: this.controller.signal });
      }

      updateMotion() {
        this.videos.forEach((video) => {
          if (this.motionPreference.matches) video.pause();
          else video.play().catch(() => {});
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kreenuts-promo-drawer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kreenuts-promo-drawer')) {
    customElements.define('kreenuts-promo-drawer', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.options = { signal: this.controller.signal };
        this.dialog = this.querySelector('[data-k-promo-dialog]');
        this.closeButton = this.querySelector('[data-k-promo-close]');
        this.tabButton = this.querySelector('[data-k-promo-tab]');
        this.tabWrap = this.querySelector('[data-k-promo-tab-wrap]');
        this.tabDismissButton = this.querySelector('[data-k-promo-tab-dismiss]');
        this.key = 'kreenuts-promo-' + this.dataset.key;
        this.tabDismissKey = this.key + '-tab-hidden';
        this.opened = false;
        this.wasScheduled = false;
        this.serverSubscribed = this.dataset.serverSubscribed === 'true';

        this.closeButton?.addEventListener('click', () => this.dialog?.close(), this.options);
        this.tabButton?.addEventListener('click', () => this.open(true), this.options);
        this.tabDismissButton?.addEventListener('click', () => this.dismissTab(), this.options);

        document.addEventListener('click', (event) => {
          const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
          if (!(link instanceof HTMLAnchorElement)) return;
          const url = new URL(link.href, window.location.href);
          if (url.hash !== '#welcome-10' && url.hash !== '#free-140g') return;
          event.preventDefault();
          this.open(true);
        }, this.options);

        this.dialog?.addEventListener('close', () => {
          this.remember();
          if (this.previousFocus?.isConnected && typeof this.previousFocus.focus === 'function') {
            this.previousFocus.focus();
          }
        }, this.options);

        this.dialog?.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          const outside =
            event.clientX < rect.left ||
            event.clientX > rect.right ||
            event.clientY < rect.top ||
            event.clientY > rect.bottom;
          if (outside) this.dialog.close();
        }, this.options);

        if (this.querySelector('[data-signup-success]')) {
          try {
            localStorage.setItem('kreenuts-newsletter-joined', '1');
            localStorage.setItem('kreenuts-welcome10-joined', '1');
          } catch {}
          if (this.tabWrap) this.tabWrap.hidden = true;
          else if (this.tabButton) this.tabButton.hidden = true;
          document.dispatchEvent(new CustomEvent('kreenuts:newsletter-subscribed'));
          this.open(true);
          return;
        }

        if (this.querySelector('[data-signup-errors]')) {
          this.open(true);
          return;
        }

        if (window.Shopify?.designMode) {
          const section = this.closest('.shopify-section');
          section?.addEventListener('shopify:section:select', () => this.open(true), this.options);
          section?.addEventListener('shopify:section:deselect', () => {
            if (this.dialog?.open) this.dialog.close();
          }, this.options);
          return;
        }

        this.syncSchedule();
      }

      parseBoundary(value) {
        if (!value) return { supplied: false, value: null };
        const timestamp = Date.parse(value);
        return { supplied: true, value: Number.isFinite(timestamp) ? timestamp : null };
      }

      scheduleState() {
        const now = Date.now();
        const start = this.parseBoundary(this.dataset.start);
        const end = this.parseBoundary(this.dataset.end);
        const valid = (!start.supplied || start.value !== null) && (!end.supplied || end.value !== null);
        const active = valid && (!start.supplied || now >= start.value) && (!end.supplied || now < end.value);
        const boundaries = [start.value, end.value].filter((value) => Number.isFinite(value) && value > now);
        return { active, nextBoundary: boundaries.length ? Math.min(...boundaries) : null };
      }

      hasJoined() {
        if (this.serverSubscribed) return true;
        try {
          return localStorage.getItem('kreenuts-welcome10-joined') === '1';
        } catch {
          return false;
        }
      }

      syncSchedule() {
        clearTimeout(this.scheduleTimer);
        const state = this.scheduleState();

        if (this.hasJoined()) {
          this.hidden = true;
          if (this.dialog?.open) this.dialog.close();
          return;
        }

        this.hidden = !state.active;
        if (this.tabWrap) this.tabWrap.hidden = this.tabDismissed();
        if (!state.active && this.dialog?.open) this.dialog.close();

        if (state.active && !this.wasScheduled) {
          this.armAutomaticTrigger();
        }

        this.wasScheduled = state.active;

        if (state.nextBoundary !== null) {
          const delay = Math.min(Math.max(state.nextBoundary - Date.now() + 50, 50), 2147483647);
          this.scheduleTimer = setTimeout(() => this.syncSchedule(), delay);
        }
      }

      armAutomaticTrigger() {
        if (this.automaticTriggerArmed) return;
        this.automaticTriggerArmed = true;

        const autoOpen = () => {
          if (this.opened || this.hasJoined() || !this.scheduleState().active || this.suppressed()) return;
          if (this.dataset.mobile !== 'true' && matchMedia('(max-width: 749px)').matches) return;
          if (document.querySelector('dialog[open]')) return;
          this.open();
        };

        if (this.dataset.trigger === 'delay') {
          this.triggerTimer = setTimeout(autoOpen, Number(this.dataset.delay) * 1000);
        }

        if (this.dataset.trigger === 'scroll') {
          const scroller = document.querySelector('.page-wrapper');
          const target = scroller || window;
          target.addEventListener('scroll', () => {
            const scrollTop = scroller ? scroller.scrollTop : window.scrollY;
            const scrollHeight = scroller ? scroller.scrollHeight : document.documentElement.scrollHeight;
            const clientHeight = scroller ? scroller.clientHeight : window.innerHeight;
            const distance = scrollHeight - clientHeight;
            if (distance > 0 && scrollTop / distance * 100 >= Number(this.dataset.scroll)) autoOpen();
          }, { ...this.options, passive: true });
        }

        if (this.dataset.trigger === 'exit') {
          document.addEventListener('mouseout', (event) => {
            if (!event.relatedTarget && event.clientY <= 0 && matchMedia('(pointer: fine)').matches) autoOpen();
          }, this.options);
        }
      }

      tabDismissed() {
        try {
          const dismissedAt = Number(localStorage.getItem(this.tabDismissKey) || 0);
          return dismissedAt > 0 && Date.now() - dismissedAt < 7 * 86400000;
        } catch {
          return false;
        }
      }

      dismissTab() {
        try {
          localStorage.setItem(this.tabDismissKey, String(Date.now()));
        } catch {}
        if (this.tabWrap) this.tabWrap.hidden = true;
        else if (this.tabButton) this.tabButton.hidden = true;
      }

      suppressed() {
        if (this.hasJoined()) return true;

        try {
          const days = Number(this.dataset.frequency);
          if (!days) return sessionStorage.getItem(this.key) === '1';
          return Date.now() - Number(localStorage.getItem(this.key) || 0) < days * 86400000;
        } catch {
          return false;
        }
      }

      remember() {
        try {
          sessionStorage.setItem(this.key, '1');
          localStorage.setItem(this.key, String(Date.now()));
        } catch {}
      }

      open(force = false) {
        if (!this.dialog || this.dialog.open) return;

        if (!force) {
          if (this.hasJoined() || this.suppressed() || !this.scheduleState().active) return;
        }

        this.hidden = false;
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
        this.opened = true;
        this.remember();

        requestAnimationFrame(() => {
          const email = this.dialog.querySelector('input[type="email"]');
          if (email instanceof HTMLElement) email.focus();
          else this.closeButton?.focus();
        });
      }

      disconnectedCallback() {
        clearTimeout(this.triggerTimer);
        clearTimeout(this.scheduleTimer);
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kreenuts-promo-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kreenuts-promo-media')) {
    customElements.define('kreenuts-promo-media', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.preference = matchMedia('(prefers-reduced-motion: reduce)');
        this.updateMotion();
        this.preference.addEventListener('change', () => this.updateMotion(), { signal: this.controller.signal });
      }
      updateMotion() {
        const video = this.querySelector('video');
        if (!video) return;
        if (this.preference.matches) video.pause();
        else if (video.autoplay) video.play().catch(() => {});
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kreenuts-reaction-reel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kreenuts-reaction-reel')) {
    customElements.define('kreenuts-reaction-reel', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
        this.videos = [...this.querySelectorAll('video[autoplay]')];
        this.updateMotion();
        this.motionPreference.addEventListener('change', () => this.updateMotion(), { signal: this.controller.signal });
      }

      updateMotion() {
        this.videos.forEach((video) => {
          if (this.motionPreference.matches) video.pause();
          else video.play().catch(() => {});
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kreenuts-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kreenuts-recently-viewed')) {
    customElements.define('kreenuts-recently-viewed', class extends HTMLElement {
      static observedAttributes = ['data-current-product-id'];

      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('click', this.handleClick, { signal: this.controller.signal });
        if (!window.Shopify?.designMode) {
          this.recordCurrentProduct();
          this.load();
        }
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name !== 'data-current-product-id' || oldValue === newValue || !this.isConnected || window.Shopify?.designMode) return;
        this.recordCurrentProduct();
        this.load();
      }

      recordCurrentProduct() {
        const currentId = this.dataset.currentProductId;
        if (!currentId) return;
        let ids = this.ids.filter((id) => id !== currentId);
        ids.unshift(String(currentId));
        ids = ids.slice(0, 12);
        try { localStorage.setItem('viewedProducts', JSON.stringify(ids)); } catch {}
      }

      handleClick = (event) => {
        if (!(event.target instanceof Element)) return;
        if (event.target.closest('[data-clear]')) this.clear();
      };

      get ids() {
        try {
          const ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
          return Array.isArray(ids) ? ids.map(String) : [];
        } catch {
          return [];
        }
      }

      async load() {
        this.requestId = (this.requestId || 0) + 1;
        const requestId = this.requestId;
        this.requestController?.abort();
        this.requestController = new AbortController();
        const currentId = this.dataset.currentProductId;
        const limit = Number(this.dataset.limit) || 4;
        const ids = this.ids.filter((id) => id !== currentId).slice(0, limit);
        if (!ids.length) return;
        const url = new URL(this.dataset.searchUrl || '/search', window.location.origin);
        url.searchParams.set('section_id', 'predictive-search');
        url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
        url.searchParams.set('resources[type]', 'product');
        try {
          const response = await fetch(url.toString(), { headers: { Accept: 'text/html' }, signal: this.requestController.signal });
          if (!response.ok) throw new Error(String(response.status));
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (requestId !== this.requestId || !this.isConnected) return;
          const cards = Array.from(documentFragment.querySelectorAll('#predictive-search-products li')).slice(0, limit);
          if (!cards.length) return;
          const grid = this.querySelector('[data-grid]');
          grid.replaceChildren();
          cards.forEach((card) => {
            const item = document.createElement('div');
            item.className = 'resource-list__item';
            item.innerHTML = card.innerHTML;

            const productLink = item.querySelector('a[href*="/products/pick-mix-72"]');
            const media = item.querySelector('.resource-card__media');
            const hasRealImage = media?.querySelector('img');
            const fallback = this.dataset.pickmix72Fallback;

            if (productLink && media && !hasRealImage && fallback) {
              media.replaceChildren();
              const image = document.createElement('img');
              image.className = 'resource-card__image';
              image.src = fallback;
              image.alt = 'Pick + Mix 72 KREENUTS mixed 72-bag box';
              image.loading = 'lazy';
              media.append(image);
            }

            item.querySelectorAll('img').forEach((image) => {
              const srcset = image.getAttribute('srcset');
              if (srcset) {
                const candidates = srcset
                  .split(',')
                  .map((candidate) => {
                    const parts = candidate.trim().split(/\s+/);
                    const width = parts[1]?.endsWith('w') ? parseInt(parts[1], 10) : 0;
                    return { url: parts[0], width };
                  })
                  .filter((candidate) => candidate.url);

                const widthCandidates = candidates.filter((candidate) => candidate.width > 0).sort((a, b) => a.width - b.width);
                const chosen = widthCandidates.find((candidate) => candidate.width >= 600) || widthCandidates.at(-1) || candidates.at(-1);

                if (chosen?.url) {
                  image.src = chosen.url;
                  image.removeAttribute('srcset');
                  image.removeAttribute('sizes');
                }
              }
              image.loading = 'lazy';
              image.decoding = 'async';
            });

            grid.append(item);
          });
          this.hidden = false;
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.hidden = true;
        }
      }

      clear() {
        this.requestId = (this.requestId || 0) + 1;
        this.requestController?.abort();
        try { localStorage.removeItem('viewedProducts'); } catch {}
        this.querySelector('[data-grid]').replaceChildren();
        this.hidden = true;
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.requestController?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kreenuts-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kreenuts-stories')) {
    customElements.define('kreenuts-stories', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.slides = Array.from(this.querySelectorAll('[data-story-slide]'));
        this.progress = Array.from(this.querySelectorAll('.k-stories__progress span'));
        this.index = 0;
        this.paused = false;
        this.autoAdvance = this.dataset.autoAdvance === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
        const options = { signal: this.controller.signal };
        this.addEventListener('click', this.handleClick, options);
        this.dialog?.addEventListener('keydown', this.handleKeydown, options);
        this.dialog?.addEventListener('close', this.handleClose, options);
        document.addEventListener('shopify:block:select', this.handleBlockSelect, options);
      }

      show(index) {
        if (!this.dialog || !this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          slide.hidden = slideIndex !== this.index;
          slide.querySelectorAll('video').forEach((video) => {
            if (slideIndex !== this.index) video.pause();
          });
        });
        this.progress.forEach((item, itemIndex) => {
          item.toggleAttribute('data-active', itemIndex === this.index);
          item.toggleAttribute('data-complete', itemIndex < this.index);
          item.removeAttribute('data-running');
          item.style.setProperty('--story-duration', `${Number(this.dataset.duration) || 5000}ms`);
        });
        if (!this.dialog.open) this.dialog.showModal();
        this.paused = false;
        this.toggleAttribute('data-paused', false);
        this.updatePauseButton();
        this.schedule();
      }

      handleClick = (event) => {
        if (!(event.target instanceof Element)) return;
        const opener = event.target.closest('[data-story-open]');
        if (opener) this.show(Number(opener.dataset.storyOpen));
        if (event.target.closest('[data-story-close]')) this.dialog?.close();
        if (event.target.closest('[data-story-previous]')) this.show(this.index - 1);
        if (event.target.closest('[data-story-next]')) this.show(this.index + 1);
        if (event.target.closest('[data-story-pause]')) this.togglePause();
      };

      handleKeydown = (event) => {
        const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        if (event.key === 'ArrowRight') this.show(this.index + direction);
        if (event.key === 'ArrowLeft') this.show(this.index - direction);
        if (event.key === 'Home') this.show(0);
        if (event.key === 'End') this.show(this.slides.length - 1);
      };

      handleBlockSelect = (event) => {
        const item = event.target.closest('.k-stories__thumbnail-item');
        if (!item || !this.contains(item)) return;
        const opener = item.querySelector('[data-story-open]');
        if (opener) this.show(Number(opener.dataset.storyOpen));
      };

      pauseVideos = () => this.querySelectorAll('video').forEach((video) => video.pause());

      schedule() {
        clearTimeout(this.timer);
        const activeProgress = this.progress[this.index];
        if (!this.autoAdvance || this.paused || !activeProgress) return;
        activeProgress.removeAttribute('data-running');
        activeProgress.offsetWidth;
        activeProgress.setAttribute('data-running', '');
        this.timer = setTimeout(() => {
          if (this.index === this.slides.length - 1 && this.dataset.loopStories !== 'true') this.dialog?.close();
          else this.show(this.index + 1);
        }, Number(this.dataset.duration) || 5000);
      }

      togglePause() {
        this.paused = !this.paused;
        this.toggleAttribute('data-paused', this.paused);
        this.updatePauseButton();
        if (this.paused) clearTimeout(this.timer);
        else this.schedule();
      }

      updatePauseButton() {
        const button = this.querySelector('[data-story-pause]');
        if (!button) return;
        button.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        const symbol = button.querySelector('[aria-hidden]');
        if (symbol) symbol.textContent = this.paused ? '▶' : 'Ⅱ';
      }

      handleClose = () => {
        clearTimeout(this.timer);
        this.pauseVideos();
      };

      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.timer);
        this.pauseVideos();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
